import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-800f7baa"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ads-account-sidebar"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "modal-paragraph"
}, " Your OMNY account is connected to the following advertisers ", -1));
const _hoisted_3 = {
  class: "account-info"
};
const _hoisted_4 = {
  class: "connected-advertisers"
};
const _hoisted_5 = {
  class: "countries"
};
const _hoisted_6 = {
  class: "profile-container"
};
const _hoisted_7 = {
  class: "profile-name"
};
const _hoisted_8 = {
  class: "advertisers-container"
};
const _hoisted_9 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "gap": "8px",
    "color": "#4D4D4D"
  }
};
const _hoisted_10 = ["src", "alt"];
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createTextVNode(" Add new DSP provider & advertiser "), /*#__PURE__*/_createElementVNode("p", null, " Adding a new advertiser will require reauthorisation with the Amazon Advertising Central ")], -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Are you sure you want to remove this account ? ", -1));
const _hoisted_13 = ["src", "alt"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_col = _resolveComponent("b-col");
  const _component_b_row = _resolveComponent("b-row");
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_WrapWithCopy = _resolveComponent("WrapWithCopy");
  const _component_app_button = _resolveComponent("app-button");
  const _component_app_modal = _resolveComponent("app-modal");
  const _component_custom_side_bar_app_modal = _resolveComponent("custom-side-bar-app-modal");
  return _openBlock(), _createBlock(_component_custom_side_bar_app_modal, {
    title: `DSP account`,
    noOk: "",
    noCancel: "",
    noFooter: "",
    custom_class: "dsp-account-sidebar-modal"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createVNode(_component_b_row, null, {
      default: _withCtx(() => [_createVNode(_component_b_col, {
        cols: "6"
      }, {
        default: _withCtx(() => [_createTextVNode(" Account Name "), _createElementVNode("p", null, _toDisplayString($props.account.account_name), 1)]),
        _: 1
      }), _createVNode(_component_b_col, {
        cols: "6"
      }, {
        default: _withCtx(() => [_createTextVNode(" Seller ID "), _createElementVNode("p", null, _toDisplayString($props.account.selling_partner_id), 1)]),
        _: 1
      })]),
      _: 1
    })]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_b_row, null, {
      default: _withCtx(() => [_createVNode(_component_b_col, {
        cols: "8"
      }, {
        default: _withCtx(() => [_createTextVNode("CONNECTED ADVERTISERS")]),
        _: 1
      }), _createVNode(_component_b_col, {
        cols: "4",
        class: "resynchronize",
        onClick: _cache[0] || (_cache[0] = $event => $options.onConnect())
      }, {
        default: _withCtx(() => [_createVNode(_component_app_icon, {
          icon: "resynchronize",
          color: "#616161",
          class: "reset-icon"
        }), _createTextVNode(" Resynchronize")]),
        _: 1
      })]),
      _: 1
    }), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.profiles, profile => {
      return _openBlock(), _createElementBlock(_Fragment, null, [$props.profiles.length ? (_openBlock(), _createElementBlock("div", {
        key: profile.account_id
      }, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(profile.accountInfo.name), 1), _createVNode(_component_WrapWithCopy, {
        class: "profileid"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(profile.account_id), 1)]),
        _: 2
      }, 1024), !_ctx.isOmnyWorkspace ? (_openBlock(), _createBlock(_component_app_button, {
        key: 0,
        loading: profile.account_id == $data.removeId ? $data.removeLoading : null,
        variant: "link",
        onClick: $event => $options.onRemoveAgencyProfile(profile)
      }, {
        default: _withCtx(() => [_createVNode(_component_app_icon, {
          icon: "remove",
          color: "#D1D1D1"
        })]),
        _: 2
      }, 1032, ["loading", "onClick"])) : _createCommentVNode("", true)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.amazonDSPAdvertiserProfilesForAgencyProfile(profile), ad_account => {
        return _openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("img", {
          class: "flag",
          src: _ctx.getCountryFlag(ad_account.country),
          alt: ad_account.country
        }, null, 8, _hoisted_10), _createElementVNode("div", null, [_createElementVNode("span", null, _toDisplayString(ad_account.advertiser_name), 1), _createVNode(_component_WrapWithCopy, {
          class: "profileid"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(ad_account.account_id), 1)]),
          _: 2
        }, 1024)])]), !_ctx.isOmnyWorkspace ? (_openBlock(), _createBlock(_component_app_button, {
          key: 0,
          loading: ad_account.account_id == $data.removeId ? $data.removeLoading : null,
          variant: "link",
          onClick: $event => $options.onRemoveAdvertiserProfile(ad_account)
        }, {
          default: _withCtx(() => [_createVNode(_component_app_icon, {
            icon: "remove",
            color: "#D1D1D1"
          })]),
          _: 2
        }, 1032, ["loading", "onClick"])) : _createCommentVNode("", true)]);
      }), 256))])) : _createCommentVNode("", true)], 64);
    }), 256)), _createElementVNode("div", {
      onClick: _cache[1] || (_cache[1] = $event => $options.onConnect()),
      class: "country add-new"
    }, [_createVNode(_component_app_icon, {
      icon: "plus",
      color: "#484C51",
      size: "20"
    }), _hoisted_11])])]), _createVNode(_component_app_modal, {
      modelValue: $data.confirmRemoveModal,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.confirmRemoveModal = $event),
      title: "Confirm Account Removing",
      "cancel-title": "No",
      "ok-title": "Yes",
      onOk: $options.onRemoveConfirm
    }, {
      default: _withCtx(() => [_hoisted_12, _createElementVNode("p", null, [_createTextVNode(_toDisplayString($data.removeAccount?.name) + " " + _toDisplayString($data.removeAccount?.account_id) + " " + _toDisplayString($data.removeAccount?.account_provider) + " " + _toDisplayString($data.removeAccount?.countryCode ?? $data.removeAccount?.country) + " ", 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.removeProfiles, profile => {
        return _openBlock(), _createElementBlock("img", {
          class: "flag",
          src: _ctx.getCountryFlag(profile.countryCode ?? profile.country),
          alt: profile.countryCode ?? profile.country
        }, null, 8, _hoisted_13);
      }), 256))])]),
      _: 1
    }, 8, ["modelValue", "onOk"])])]),
    _: 1
  });
}